import React from "react";
import { RainFormData } from "../types";

interface Props {
  form: RainFormData;
  onChange: (patch: Partial<RainFormData>) => void;
}

const ContextStep: React.FC<Props> = ({ form, onChange }) => {
  return (
    <div className="rw-step">
      <h2 className="rw-step-title">Add context</h2>
      <p className="rw-step-subtitle">
        Everything here is optional, but good context leads to better
        decisions.
      </p>

      <label className="rw-label" htmlFor="rw-context">
        Background
      </label>
      <textarea
        id="rw-context"
        className="rw-input rw-textarea"
        placeholder="Any background information that helps understand the question - what the market is about, where to look, known circumstances..."
        value={form.context}
        rows={5}
        onChange={(e) => onChange({ context: e.target.value })}
      />

      <label className="rw-label" htmlFor="rw-pool-date">
        Market creation date
        <span className="rw-label-hint">
          helps the judge understand the timeframe
        </span>
      </label>
      <input
        id="rw-pool-date"
        type="date"
        className="rw-input rw-date"
        value={form.poolCreationDate}
        onChange={(e) => onChange({ poolCreationDate: e.target.value })}
      />

      <label className="rw-label" htmlFor="rw-ai-decision">
        Previous AI decision
        <span className="rw-label-hint">
          paste a decision from another model to be weighed as input
        </span>
      </label>
      <textarea
        id="rw-ai-decision"
        className="rw-input rw-textarea"
        placeholder="Optional - paste a prior decision or recommendation..."
        value={form.aiDecision}
        rows={4}
        onChange={(e) => onChange({ aiDecision: e.target.value })}
      />
    </div>
  );
};

export default ContextStep;
